import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import SwmService from '../../services/swmServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk(
  'swm/list',
  async ({ page, perPage, sort, orderBy, search, jenjang_id, mapel_id, bab_id, created_by, start_date, end_date }, thunkAPI) => {
    try {
      const response = await SwmService.getList(
        page,
        perPage,
        sort,
        orderBy,
        search,
        jenjang_id,
        mapel_id,
        bab_id,
        created_by,
        start_date,
        end_date
      );
      return response.data;
    } catch (error) {
      if (error.response.status == 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getListArchive = createAsyncThunk(
  'swm/getListArchive',
  async ({ page, perPage, sort, orderBy, search, jenjang_id, mapel_id, bab_id, created_by, start_date, end_date }, thunkAPI) => {
    try {
      const response = await SwmService.getListArchive(
        page,
        perPage,
        sort,
        orderBy,
        search,
        jenjang_id,
        mapel_id,
        bab_id,
        created_by,
        start_date,
        end_date
      );
      return response.data;
    } catch (error) {
      if (error.response.status == 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createData = createAsyncThunk('swm/create', async (data, thunkAPI) => {
  try {
    const response = await SwmService.create(data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('swm/read', async (id, thunkAPI) => {
  try {
    const response = await SwmService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateData = createAsyncThunk('swm/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await SwmService.update(id, data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('swm/delete', async (id, thunkAPI) => {
  try {
    const response = await SwmService.del(id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    if (error.response.status == 404) {
      thunkAPI.dispatch(getList());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('swm/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await SwmService.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getRatings = createAsyncThunk('swm/getRatings', async ({ id, page, perPage, sort, orderBy }, thunkAPI) => {
  try {
    const response = await SwmService.getRatings(id, page, perPage, sort, orderBy);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getHistory = createAsyncThunk('swm/getHistory', async (id, thunkAPI) => {
  try {
    const response = await SwmService.getHistory(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getSession = createAsyncThunk('swm/getSession', async ({ id, sessionID }, thunkAPI) => {
  try {
    const response = await SwmService.getSession(id, sessionID);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getPreview = createAsyncThunk('swm/getPreview', async ({ id, stageIdx, itemIdx }, thunkAPI) => {
  try {
    const response = await SwmService.getPreview(id, stageIdx, itemIdx);
    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const storeStage = createAsyncThunk('swm/storeStage', async ({ id, data }, thunkAPI) => {
  try {
    const response = await SwmService.storeStage(id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateStage = createAsyncThunk('swm/updateStage', async ({ id, stageId, data }, thunkAPI) => {
  try {
    const response = await SwmService.updateStage(id, stageId, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const destroyStage = createAsyncThunk('swm/destroyStage', async ({ id, stageId }, thunkAPI) => {
  try {
    const response = await SwmService.destroyStage(id, stageId);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const storeStageItem = createAsyncThunk('swm/storeStageItem', async ({ id, stageId, data }, thunkAPI) => {
  try {
    const response = await SwmService.storeStageItem(id, stageId, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateStageItem = createAsyncThunk('swm/updateStageItem', async ({ id, stageId, itemId, data }, thunkAPI) => {
  try {
    const response = await SwmService.updateStageItem(id, stageId, itemId, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const destroyStageItem = createAsyncThunk('swm/destroyStageItem', async ({ id, stageId, itemId }, thunkAPI) => {
  try {
    const response = await SwmService.destroyStageItem(id, stageId, itemId);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListQuestion = createAsyncThunk(
  'swm/getListQuestion',
  async ({ id, stageId, itemId, page, perPage, sort, orderBy, search }, thunkAPI) => {
    try {
      const response = await SwmService.getListQuestion(id, stageId, itemId, page, perPage, sort, orderBy, search);
      return response.data;
    } catch (error) {
      if (error.response.status == 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const addQuestion = createAsyncThunk('swm/addQuestion', async ({ id, stageId, itemId, data }, thunkAPI) => {
  try {
    const response = await SwmService.addQuestion(id, stageId, itemId, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getQuestion = createAsyncThunk('swm/getQuestion', async ({ id, stageId, itemId, soalId }, thunkAPI) => {
  try {
    const response = await SwmService.getQuestion(id, stageId, itemId, soalId);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateQuestion = createAsyncThunk('swm/updateQuestion', async ({ id, stageId, itemId, soalId, data }, thunkAPI) => {
  try {
    const response = await SwmService.updateQuestion(id, stageId, itemId, soalId, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteQuestion = createAsyncThunk('swm/deleteQuestion', async ({ id, stageId, itemId, soalId }, thunkAPI) => {
  try {
    const response = await SwmService.deleteQuestion(id, stageId, itemId, soalId);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = {
  isLoading: false,
  list: [],
  data: [],
  ratings: null,
  soal: null,
  listSoal: null,
  error: [],
  group: {},
  session: [],
  stage: null,
  item: null,
  page: null,
  progress: 0
};

const matchwordSlice = createSlice({
  name: 'swm',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
        state.error = [];
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.errors ?? [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
        state.error = [];
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.errors ?? [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getRatings.pending, (state) => {
        state.isLoading = true;
        state.ratings = null;
      }),
      builder.addCase(getRatings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ratings = action.payload;
      }),
      builder.addCase(getRatings.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getHistory.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.group = action.payload.session;
      }),
      builder.addCase(getHistory.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getSession.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getSession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.session = action.payload.session;
      }),
      builder.addCase(getSession.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getPreview.pending, (state) => {
        state.isLoading = true;
        state.item = null;
      }),
      builder.addCase(getPreview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.stage = action.payload.stage;
        state.item = action.payload.item;
        state.page = action.payload.page;
      }),
      builder.addCase(getPreview.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storeStage.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(storeStage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(storeStage.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateStage.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateStage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(updateStage.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(destroyStage.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(destroyStage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(destroyStage.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storeStageItem.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(storeStageItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(storeStageItem.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateStageItem.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateStageItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(updateStageItem.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(destroyStageItem.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(destroyStageItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(destroyStageItem.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListQuestion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listSoal = action.payload;
      }),
      builder.addCase(getListQuestion.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addQuestion.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addQuestion.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getQuestion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.soal = action.payload;
      }),
      builder.addCase(getQuestion.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateQuestion.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateQuestion.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteQuestion.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteQuestion.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = matchwordSlice;
export default reducer;
